import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicElement = ({ element }) => {
    const authacc = useSelector(state => state.authacc);
    return authacc.user_id > 0 ? <Navigate to="/dashboard" /> : element;
};

export default PublicElement;